import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { SearchResult } from '@marageti/z4-sdk/lib/entity';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { useAuthStore } from '../../../store';
import useTicketsSearch from '../../../hooks/use-tickets-search';
import useTicketListActions from '../../../hooks/use-ticket-list-actions';
import {
  AssigneeOption,
  formatTeamMembersAsOptions,
  teamMemberSearchRequest,
} from '../../tickets/options';
import TravelerTicketsView from './tickets-view';

const TravelerTicketsContainer = () => {
  const { travelerId } = useParams<{ travelerId: string }>();
  const apiClient = useApiClient();
  const { loggedInTeamMember } = useAuthStore();

  const {
    tickets, totalHits, isLoading, error, hasMore, loadMore, refetch,
  } = useTicketsSearch({
    travelerId,
    sort: 'createdAt:desc',
  });

  const { data: teamMembers } = useFetch<SearchResult<TeamMember>>(
    apiClient.peopleClient.postTeamMemberSearch,
    [teamMemberSearchRequest],
    true,
  );

  const assignees = useMemo<AssigneeOption[]>(() => {
    const options = formatTeamMembersAsOptions(teamMembers, []);
    return options.filter((option) => option.value);
  }, [teamMembers]);

  const {
    isModalOpen,
    editingTicket,
    handleEditTicket,
    handleCloseModal,
    handleSaveTicket,
    isCloseModalOpen,
    handleCloseCloseModal,
    handleSaveClose,
    isReassignModalOpen,
    reassigningTicketAssigneeIds,
    handleReassignTicket,
    handleCloseReassignModal,
    handleSaveReassign,
    isDeleteModalOpen,
    handleDeleteTicket,
    handleCloseDeleteModal,
    handleConfirmDelete,
    handleStatusChange,
  } = useTicketListActions(refetch);

  return (
    <TravelerTicketsView
      tickets={tickets}
      totalHits={totalHits}
      isLoading={isLoading}
      error={error || undefined}
      hasMore={hasMore}
      loadMore={loadMore}
      onEditTicket={handleEditTicket}
      onReassignTicket={handleReassignTicket}
      onDeleteTicket={handleDeleteTicket}
      onStatusChange={handleStatusChange}
      isModalOpen={isModalOpen}
      editingTicket={editingTicket}
      assignees={assignees}
      defaultAssigneeIds={loggedInTeamMember?.id ? [loggedInTeamMember.id] : []}
      onCloseModal={handleCloseModal}
      onSaveTicket={handleSaveTicket}
      isCloseModalOpen={isCloseModalOpen}
      onCloseCloseModal={handleCloseCloseModal}
      onSaveClose={handleSaveClose}
      isReassignModalOpen={isReassignModalOpen}
      reassigningTicketAssigneeIds={reassigningTicketAssigneeIds}
      onCloseReassignModal={handleCloseReassignModal}
      onSaveReassign={handleSaveReassign}
      isDeleteModalOpen={isDeleteModalOpen}
      onCloseDeleteModal={handleCloseDeleteModal}
      onConfirmDelete={handleConfirmDelete}
    />
  );
};

export default TravelerTicketsContainer;
